import { render } from "./Retiradas.vue?vue&type=template&id=55ce14e2"
import script from "./Retiradas.vue?vue&type=script&lang=js"
export * from "./Retiradas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__